// extracted by mini-css-extract-plugin
export default {"StatsContainer":"PlayerStatisticsTable_StatsContainer__uO2EJ","EventName":"PlayerStatisticsTable_EventName__2IqKe","TableContainer":"PlayerStatisticsTable_TableContainer__7fHm7"};